export const en = {
  nav_home: "Home",
  nav_drill: "Try the drill",
  nav_new: "Seal a vault",
  nav_checkin: "Check in",
  nav_custodian: "Custodians",
  nav_vaults: "All vaults",
  nav_verify: "Verify without us",

  hero_kicker: "For RTI activists, whistleblowers and the people who stand with them",
  hero_title: "If my heartbeat stops, the truth comes out.",
  hero_body: "For India's RTI filers: know your reply deadline and appeal dates today, and if the work turns dangerous, seal your evidence so that silencing you releases it.",
  hero_cta_drill: "Watch it happen in 5 minutes",
  hero_cta_new: "Seal a real vault",
  hero_note: "Runs on Arkiv's Tiramisu testnet. Use test documents only.",

  why_title: "Why this exists",
  why_1_n: "107+",
  why_1: "people killed for seeking information under the RTI Act since 2005 (CHRI tracker).",
  why_2_n: "12 yrs",
  why_2: "the Whistle Blowers Protection Act, 2014 has waited to come into force.",
  why_3_n: "0",
  why_3: "tools that release an activist's findings automatically if they are silenced.",
  why_story: "After RTI users were murdered in Maharashtra, researchers found that some families had burned the documents out of fear. The Information Commission once ordered that whatever a killed activist had asked for be published at once. Proof of Life makes that order automatic, and takes away the reason to kill.",

  how_title: "How it works",
  how_1_t: "Seal",
  how_1: "Your files are encrypted in this browser. Only ciphertext goes to Arkiv, and it is handed to an address nobody controls, so it cannot be deleted, even by you.",
  how_2_t: "Choose custodians",
  how_2: "A journalist, a lawyer, a friend. Each holds one piece of the key. Any {k} of them together can open the vault; fewer learn nothing.",
  how_3_t: "Check in",
  how_3: "Your heartbeat is an Arkiv entity that only your key can keep alive. One tap pushes it forward. Miss the deadline and the grace period, and it simply stops existing.",
  how_4_t: "Release",
  how_4: "Custodians see the heartbeat is gone and publish their pieces. Once enough are public, anyone's browser can open the documents. No server decides.",

  phase_alive: "Alive",
  phase_overdue: "Overdue",
  phase_lapsed: "Heartbeat stopped",
  phase_releasing: "Releasing",
  phase_released: "Released",
  phase_alive_d: "Checked in. The documents stay sealed.",
  phase_overdue_d: "Past the check-in time. Custodians should try to reach the activist now.",
  phase_lapsed_d: "No check-in before the deadline. Custodians may now publish their pieces.",
  phase_releasing_d: "{have} of {k} pieces are public. {need} more opens the vault.",
  phase_released_d: "Enough pieces are public. Anyone can open these documents.",

  t_due_in: "Check-in due in",
  t_lapses_in: "Stops beating in",
  t_ago: "ago",
  early_release: "Pieces were published while the heartbeat still beats. Either the activist sent a duress signal that only custodians can read, or custodians broke the rules.",

  v_custodians: "Custodians",
  v_custodian_slot: "Slot {slot}",
  v_ack_live: "Holding the key · renews in {time}",
  v_ack_missing: "Has not confirmed",
  v_released_piece: "Piece published",
  v_open: "Open the documents",
  v_opening: "Rebuilding the key and decrypting…",
  v_files: "Documents",
  v_verified: "Every file matches the hash sealed at block {block}. These are the documents as they were on {date}.",
  v_sealed_yes: "Sealed: read-only and owned by an address nobody holds",
  v_sealed_no: "Not sealed: the creator could still delete this manifest",
  v_rejected: "Ignored entities",
  v_rejected_d: "These claim to belong to this vault but fail a trust check. Anyone can write them; nobody can make them count.",
  v_keepalive: "Keep this vault alive for at least a year from today",
  v_keepalive_d: "Anyone can extend sealed vault data. You pay a few cents of test gas; you cannot change or delete anything.",
  v_newsroom: "These pieces are sealed to the newsroom key. Only that newsroom can open the documents and decide what to publish.",
  v_live: "Live",
  v_events: "Live activity",

  use_title: "What this is for, and what it is not",
  use_body: "Proof of Life helps people who use their legal rights, such as RTI applicants, journalists and lawyers, make sure their lawfully obtained records survive them. Seal RTI replies, public records and your own evidence. Do not seal classified material, other people's personal data, or anything you could not lawfully hold. For real use, release to a newsroom, so editors check documents before anything is published. This build runs on a test network with synthetic documents only.",
  hero_title_a: "If my heartbeat stops,",
  hero_title_b: "the truth comes out.",
  trust_1: "Free and open source",
  trust_2: "No wallet or app to install",
  why_h2_a: "The evidence dies",
  why_h2_b: "with the person who found it.",
  old_eyebrow: "Today",
  old_title: "A folder on a laptop and a copy with a friend",
  old_1: "A laptop can be seized, and a drive can be wiped.",
  old_2: "A friend with the only copy can be threatened into silence.",
  old_3: "Nobody else knows the papers exist until it is too late.",
  new_eyebrow: "With Proof of Life",
  new_title: "A sealed record that opens on its own schedule",
  new_1: "The encrypted record sits on Arkiv, and no one can delete it.",
  new_2: "The release does not depend on any single person, server or company.",
  new_3: "Killing the activist releases the findings, so it no longer buries them.",
  f1_title: "Encrypted on your phone, undeletable on Arkiv.",
  f1_chip_2: "Hashes sealed at creation",
  f2_title: "Trust split between people you choose.",
  f2_chip_1: "k of n",
  f2_chip_2: "One-time custodian keys",
  f2_chip_3: "Release to a newsroom",
  f3_title: "One tap a week keeps it sealed.",
  f3_chip_1: "Weekly or monthly",
  f3_chip_2: "Grace period",
  f3_chip_3: "Duress passphrase",
  f4_title: "When the heartbeat stops, anyone can read it.",
  f4_chip_1: "Forged pieces ignored",
  f4_chip_2: "Opens in any browser",
  try_eyebrow: "Try it on this page",
  try_h2: "A year of check\u2011ins in a minute.",
  try_lead: "Pick a rhythm and how many custodians must agree, then stop checking in and watch what happens. One day passes every second.",
  sim_rhythm: "Check-in rhythm",
  sim_k: "Custodians needed to release: {k}",
  sim_auto: "I keep checking in",
  sim_auto_d: "Turn this off to go silent.",
  sim_checkin: "Check in now",
  sim_reset: "Start over",
  sim_note: "This box is a local simulation. The drill runs the same thing on the real Arkiv testnet.",
  sim_due: "Next check-in in {d} days",
  arkiv_eyebrow: "Why it runs on Arkiv",
  arkiv_h2_a: "The database keeps the deadline.",
  arkiv_h2_b: "Nobody has to keep a server alive.",
  tile_1_t: "Expiry the database enforces",
  tile_1: "The heartbeat is an Arkiv entity that lives for one interval plus grace. If nobody extends it, Arkiv drops it.",
  tile_2_t: "Data nobody can delete",
  tile_2: "Every sealed piece is read-only and belongs to an address nobody holds, from the block it is written.",
  tile_3_t: "Authorship nobody can forge",
  tile_3: "A piece counts only if its on-chain creator is the custodian named for that slot.",
  tile_4_t: "Readable without us",
  tile_4: "This site, the command-line tool and a curl command all read the same public entities.",
  tile_5_t: "Live over a WebSocket",
  tile_5: "Check-ins and releases appear on every open vault page the moment they land.",
  tile_6_t: "Nothing kept on your phone",
  tile_6: "Keys are sealed under your passphrase, and the app finds your vaults on Arkiv instead of storing a list.",
  faq_eyebrow: "Questions",
  faq_h2: "What people ask first.",
  faq_1_q: "Can someone stop the release?",
  faq_1_a: "Arkiv enforces the deadline and keeps the encrypted record. The release itself needs k of your custodians to publish their pieces. If enough of them are silenced or refuse, the vault stays sealed. That is why you choose people in different places and set k below the total.",
  faq_2_q: "What if I lose my phone?",
  faq_2_a: "Restore your backup file on a new phone and enter your passphrase. Keep the backup away from the phone, for example with someone you trust. Without the passphrase it is random text.",
  faq_3_q: "What if someone forces me to check in?",
  faq_3_a: "Set a duress passphrase when you create the vault. A check-in with it looks exactly like a normal one, on your screen and on the public vault page. Inside, each check-in carries a note encrypted to your custodians, and this one tells them to release now.",
  faq_4_q: "Can a custodian read my documents early?",
  faq_4_a: "One piece reveals nothing. Pieces published while the heartbeat still beats are flagged on the vault page as an early release, and fewer than k pieces still open nothing.",
  faq_5_q: "What does someone watching the chain see?",
  faq_5_a: "Random ids, ciphertext, a deadline and the times you check in. They don't see names, titles or which vaults belong to the same person. Check-in times are visible, so check in at the times you would anyway.",
  faq_6_q: "Is this legal?",
  faq_6_a: "It is encryption software for records you are allowed to hold, such as RTI replies, public records and your own evidence. Don't seal classified material or other people's personal data. For real use, release to a newsroom so editors check documents before anything is published.",
  faq_7_q: "Why a test network?",
  faq_7_a: "This build runs on Arkiv's Tiramisu testnet for the Arkiv Global Tour Stop. Use synthetic documents only.",
  final_a: "Don't keep your evidence alone.",
  final_b: "Seal it, and check in.",
  final_cta_2: "See a released vault",
  common_loading: "Reading from Arkiv…",
  common_error: "Could not read from Arkiv",
  common_retry: "Try again",
  common_copy: "Copy",
  common_copied: "Copied",
  common_tx: "transaction",
  common_block: "block",
  common_testnet: "Testnet only. Never seal real personal data here.",
  read_direct: "Reading straight from Arkiv",
  read_relay: "Reading through our relay (Arkiv's free read limit was reached)",
  vl_all: "All",
  vl_soon: "Stops within 3 days",
  vl_slow: "Weekly check-in or slower",
  vl_filter_note: "These filters run on the Arkiv node as range queries over each heartbeat's expiry and each vault's check-in interval.",
  vl_rel_t: "Released evidence",
  vl_rel_b: "Vaults whose pieces are public. A vault can stay unlisted while its heartbeat beats; every released piece carries the project tag and its vault's creator, so released evidence is findable from the chain alone.",
  vl_pieces: "{n} piece(s) · since block {b}",
  vl_intro: "Every listed vault on Arkiv, read live. A vault shows only a random id, its custodian count and its heartbeat. Nothing here says who made it or what is inside. Release counts include only pieces that pass the vault's checks; forged ones show as ignored.",
  vl_row: "{k} of {n} custodians · {mode} release · by {by}",
  rti_bk_t: "If you reach a Second Appeal",
  rti_bk_lead: "Second Appeals go to your state's information commission, or to the Central Information Commission for a central government office. Pick yours to see what its backlog looks like.",
  rti_bk_pick: "Information commission",
  rti_bk_choose: "Choose a commission",
  rti_bk_wait: "Estimated wait for a matter filed on 1 July 2025: {wait}.",
  rti_bk_years: "{y} years",
  rti_bk_years_months: "{y} years {m} months",
  rti_bk_defunct: "This commission had no commissioners as of 7 October 2025, so nobody was there to hear appeals.",
  rti_bk_nochief: "It was working without a Chief Information Commissioner in October 2025.",
  rti_bk_reduced: "It was working with fewer commissioners than the law allows, while cases piled up.",
  rti_bk_none: "The report's summary gives no separate figure for this commission.",
  rti_bk_all: "Across India, {n} appeals and complaints were pending on 30 June 2025, and 18 of the 29 commissions would take more than a year to decide a matter filed on 1 July 2025. File your First Appeal on time: it is the step you control.",
  rti_bk_src: "Source: Satark Nagrik Sangathan, Report Card on the Performance of Information Commissions in India, 2024-25 (press release, 9 October 2025).",
  home_rti_n1: "17,50,863",
  home_rti_s1: "RTI applications filed in 2023-24, according to the Union government's reply in the Rajya Sabha.",
  home_rti_n2: "4,13,972",
  home_rti_s2: "appeals and complaints pending in India's 29 information commissions on 30 June 2025.",
  home_rti_n3: "29 yrs",
  home_rti_s3: "estimated wait for a matter at the Telangana commission, filed on 1 July 2025.",
  home_rti_next: "For the few whose RTI work puts them in danger, the vault is the next layer.",
  hero_cta_rti: "Check your RTI deadline",
  rti_tally_line: "Recorded with this clock for this commission: {n}, of which {late} are past their reply deadline. Counted live from Arkiv.",
  rti_tally_zero: "No application for this commission has been added to the public count yet.",
  rti_tally_note: "Filers choose to be counted when they record an application. Anyone can add to the count, so read it as a signal from filers, not an audit of the commission.",
  rti_tally_opt: "Also add this application, anonymously, to the public count for {name}. Only the commission and the reply deadline go on Arkiv.",
  rti_tally_pick: "To add this application to a commission's public count, choose your information commission above.",
  // Key, check-in, custodian and sealing flows
  nv_reused: "One of these invite codes already guards another vault. Reusing it would link your vaults on Arkiv. Ask that custodian for a fresh invite code.",
  kg_no_key_activist: "That passphrase opens no activist key in this browser.",
  kg_no_key_custodian: "That passphrase opens no custodian key in this browser.",
  kg_short: "Use at least 8 characters. A short sentence is best.",
  kg_differ: "The two passphrases differ.",
  kg_ready_t: "Your key is ready",
  kg_ready_b: "A backup file just downloaded. Keep it away from this phone, for example with someone you trust. Without your passphrase it is a few lines of random text.",
  kg_ready_warn: "If you lose both this browser and the backup, you cannot check in, and the vault will be released when the deadline passes. That is how it is meant to work.",
  kg_continue: "Continue",
  kg_again: "Download the backup again",
  kg_addr: "Key address",
  kg_unlock: "Unlock",
  kg_unlocking: "Unlocking…",
  kg_new: "Make a new key",
  kg_restore: "Restore a backup",
  kg_restored: "{n} key(s) restored. Enter the passphrase.",
  kg_pass: "Passphrase",
  kg_label: "A label only you will see",
  kg_label_hint: "Shown after you unlock, to tell keys apart. Never a real name.",
  kg_pass_hint: "At least 8 characters. A sentence only you would write works well. You can use the same one for every vault.",
  kg_pass2: "Passphrase again",
  kg_duress: "Duress passphrase (optional)",
  kg_duress_hint: "If someone forces you to check in, use this one instead. The check-in looks normal on your screen and on the public vault page. Its encrypted note tells your custodians to release now. Nothing stored on this phone shows that a duress passphrase exists.",
  kg_making: "Making the key…",
  kg_make: "Make the key and download its backup",
  ci_gate_t: "Unlock to check in",
  ci_gate_i: "One passphrase opens every vault key in this browser.",
  ci_jitter_wait: "Your check-in will go out in about {m} minutes. Keep this page open.",
  ci_done: "Checked in at {time}. Your documents stay sealed.",
  ci_busy: "Checking in…",
  ci_btn_one: "I'm safe · check in 1 vault",
  ci_btn_many: "I'm safe · check in {n} vaults",
  ci_jitter: "Send at a random moment in the next 1 to 20 minutes",
  ci_none: "No vault of these keys still has a heartbeat.",
  ci_key: "Key",
  ci_due: "Next check-in due in {d}",
  ci_grace: "You are in the grace period. Check in now.",
  cu_title: "Custodians",
  cu_intro: "You hold one piece of a key. Alone it reveals nothing. You promise two things: to try to reach the activist if their heartbeat is overdue, and to publish your piece if it stops. Use a new key for every vault, so nothing on Arkiv connects your vaults to each other or to you.",
  cu_gate_stored: "Unlock your custodian keys, or make one for a new vault",
  cu_gate_new: "Make a custodian key for one vault",
  cu_another: "Make another custodian key",
  cu_invite: "Invite code",
  cu_invite_b: "Send this to the activist through a channel you both trust. It holds only this key's public half.",
  cu_looking: "Looking for vaults that name this key…",
  cu_none: "No vault names this key yet. Once the activist seals one with your invite code, it shows up here.",
  cu_slot: "Slot {slot} of {n} · {k} needed to release",
  cu_duress: "The activist's last check-in used their duress passphrase. Only you and the other custodians can see this. Publish your piece now.",
  cu_overdue: "The activist is late. Try to reach them now, through the channel you agreed on.",
  cu_renewed: "Custody renewed for 14 days.",
  cu_confirmed: "Custody confirmed.",
  cu_renew: "Renew custody ({left} left)",
  cu_confirm: "Confirm I hold my key",
  cu_published: "Your piece is public.",
  cu_piece_done: "Piece published",
  cu_publish: "Publish my piece",
  cu_early: "Publishing unlocks only after the heartbeat stops. The app and the CLI both refuse earlier, and a piece published early is flagged on the vault page.",
  cu_watch_t: "Run your own watcher",
  cu_watch_b: "You don't have to keep this page open. A watcher on your own computer, or an hourly job on your own GitHub account, renews your custody and publishes your piece the moment the heartbeat stops or a duress check-in arrives. Nothing of ours is involved, and if the activist is late the job fails and GitHub emails you.",
  cu_watch_link: "Set up a watcher",
  nv_rh_daily: "Every day",
  nv_rh_weekly: "Every week",
  nv_rh_fortnight: "Every two weeks",
  nv_rh_monthly: "Every month",
  nv_rh_test: "Test: every 10 minutes",
  nv_gate_t: "A new key for this vault",
  nv_gate_i: "Every vault gets its own key. On Arkiv, everything a key writes can be listed with one query, so a fresh key per vault means nobody can tell that two vaults belong to the same person. You can use the same passphrase for all of them.",
  nv_enc: "Encrypted {n} file(s) in this browser; {c} ciphertext chunk(s).",
  nv_owngas_wait: "Send at least {glm} GLM on Arkiv Tiramisu to {addr} from your own wallet or the faucet. Waiting…",
  nv_chunk: "Chunk {d}/{t} sealed",
  nv_manifest: "Manifest, envelopes and heartbeat sealed together",
  nv_done_t: "Sealed. Your heartbeat has started.",
  nv_done_b: "Check in within {i}. You have {g} of grace after that.",
  nv_send_link: "Send this link to each custodian",
  nv_open: "Open the vault page",
  nv_checkin: "Check-in page",
  nv_s1: "1 · Documents",
  nv_s1_b: "Up to about 1.4 MB after compression. Photos of RTI replies are shrunk on this phone first, so a multi-page reply usually fits. Test documents only on this testnet.",
  nv_count: "{n} file(s) · {size}",
  nv_too_big: "Too large. Keep the total under 1.4 MB.",
  nv_title_l: "Title (encrypted, only readable after release)",
  nv_note_l: "A note for whoever reads this after release (encrypted)",
  nv_s2: "2 · Custodians",
  nv_s2_b: "Ask each person to open the Custodians page and send you their invite code. Each code is a fresh key made for your vault only, so nothing on Arkiv links it to who they are.",
  nv_add: "Add a custodian",
  nv_dup: "The same custodian appears twice.",
  nv_k: "How many must act together to release: {k} of {n}",
  nv_k_hint: "Two or more protects you from one custodian acting alone. Fewer than all protects you from one being unreachable.",
  nv_s3: "3 · Rhythm and release",
  nv_grace: "grace {d}",
  nv_public: "Release to everyone. Anyone can open the documents once enough pieces are out.",
  nv_newsroom: "Release to one newsroom. Pieces are sealed to its key; its editors check the documents before anything is published.",
  nv_newsroom_ph: "Newsroom public key, 0x02… or 0x03…",
  nv_anyone_t: "Let anyone keep the evidence alive",
  nv_anyone_b: "Recommended. After a release, supporters can extend the encrypted data so it outlives you. Turn off to keep its lifetime in your hands alone.",
  nv_owngas_t: "Pay gas from my own wallet",
  nv_owngas_b: "Off: a shared tap sends this key a little test GLM, and the tap's address links every key it funds. On: send GLM to this key yourself, for example with the faucet's \"Use a different address\".",
  nv_listed_t: "List this vault in the public directory",
  nv_listed_b: "Off by default. An unlisted vault carries no project tag and no plain type, so no search lists it. Someone scanning the whole chain could still spot that a vault exists, never what is in it or whose it is.",
  nv_what: "What goes on Arkiv",
  nv_pub_h: "Public, forever readable",
  nv_you_h: "Stays with you",
  nv_r1a: "Encrypted chunks and their hashes",
  nv_r1b: "The files, the title, the note",
  nv_r2a: "Each custodian's one-time address and public key",
  nv_r2b: "Who the custodians are",
  nv_r3a: "Your heartbeat and its deadline",
  nv_r3b: "Your key and passphrase",
  nv_r4a: "{k} of {n}, rhythm, release mode",
  nv_r4b: "Anything that names you, and any label you give the vault",
  nv_watch: "Someone watching the chain can see when you check in, and the Arkiv node sees the IP address you check in from. Check in at times you would be online anyway, over Tor or a VPN you already use.",
  nv_agree: "I understand nobody can delete this vault once sealed, me included, and that missing check-ins releases it. These are lawfully obtained records, with no classified material and no other person's private data.",
  nv_sealing: "Sealing…",
  nv_seal: "Seal and start my heartbeat",

  dr_kicker: "Five-minute drill",
  dr_title: "Watch a vault live, die and speak.",
  dr_body: "This tab plays one activist and three custodians. Every step is a real write to Arkiv's Tiramisu testnet, with a link to the transaction. The clock is shrunk: check in every minute, one minute of grace.",
  dr_note_label: "A line to seal with the synthetic RTI reply",
  dr_note_default: "The real figures are in the measurement book, page 14.",
  dr_unreachable: "Custodian 2 is unreachable when it matters",
  dr_forge: "A forger tries to publish a fake piece",
  dr_start: "Start the drill",
  dr_public: "Public vault page →",
  dr_due: "Check-in due in",
  dr_now: "now",
  dr_stops: "Stops beating in",
  dr_pieces: "{have} of {k} pieces public",
  dr_checkin: "Check in",
  dr_force: "Force deletion",
  dr_or: "Or stop pressing anything and let it lapse.",
  dr_out_t: "The documents are out.",
  dr_out: "Open the public page in another browser, on another phone, or through the CLI. It rebuilds the key from the pieces on Arkiv and decrypts, with no help from this tab or from our servers.",
  dr_open: "Open the public vault page",
  dr_log_t: "What just happened on Arkiv",
  dr_log_none: "Nothing yet.",
  dr_activist: "Activist",
  dr_c1: "Custodian 1 · journalist",
  dr_c2: "Custodian 2 · lawyer",
  dr_c3: "Custodian 3 · friend",
  dr_forger: "Forger",
  dr_l_keys: "Made 5 fresh keys in this tab. Activist {a}.",
  dr_l_tap: "Activist received test gas from the tap.",
  dr_l_gas: "Gas to {name}",
  dr_l_enc: "Encrypted 2 files in the browser. Key split 2-of-3. Vault {v}.",
  dr_l_chunk: "Ciphertext chunk {d}/{t} written and sealed",
  dr_l_batch: "Manifest, 3 envelopes and the heartbeat written in one batch",
  dr_l_ack: "{name} confirmed custody",
  dr_l_beat: "Activist checked in",
  dr_l_coerce: "Coercion: the activist is forced to delete the heartbeat. That only stops it sooner.",
  dr_l_gone: "Custodians' watchers: heartbeat gone. Releasing.",
  dr_l_fake: "A forger published a fake piece for slot 2",
  dr_l_unreach: "Custodian 2 is unreachable. 2 of 3 is still enough.",
  dr_l_piece: "{name} published a piece",
  vf_lead: "If this website disappears tomorrow, every vault is still on Arkiv, and any of these can read it.",
  vf_cli_t: "The CLI",
  vf_cli: "Status, watch, release and open from a terminal. No browser, no site.",
  vf_curl: "One JSON-RPC call to {rpc}.",
  vf_src_t: "The source",
  vf_src: "MIT licensed, with the data contract in /arkiv/schema.md, so anyone can build another reader.",
  vf_run_t: "Run a query",
  vf_run: "Run on Arkiv",
  vp_on_arkiv: "On Arkiv",
  vp_chunks: "{n} encrypted chunk(s), {size}, sealed by",
  vp_envelopes: "{have} of {n} key envelopes sealed",
  vp_kept: "Vault data kept until block {b} (~{d})",
  vp_sealed_at: "Sealed at block {b} · {date}",
  vp_waiting: "Waiting for check-ins, acknowledgements and releases…",
  vp_mismatch: "Some files do not match their sealed hash.",
  vp_download: "Download",
  ka_gas: "Getting test gas…",
  ka_none: "Everything is already kept for at least a year.",
  ka_extending: "Extending {n} sealed entities…",
  ka_done: "Done",
  as_t: "As of an earlier block",
  as_d: "The same query, read at a past block with Arkiv's atBlock. It proves what state the vault was in at that moment, for example that the activist was still checking in.",
  as_read: "Read",
  as_reading: "Reading…",
  as_at: "At block {b}: {phase}",
  as_hb: ", heartbeat valid until block {b}",
  as_nohb: ", no heartbeat",
  as_pieces: ", {n} valid piece(s).",
  vy_t: "Check this without us",
  vy_d: "Every fact on this page comes from these Arkiv queries. Run them against any Arkiv endpoint.",
  ev_checkin: "Check-in at block {b}",
  ev_activity: "Custodian activity at block {b}",
  ev_deadline: "Deadline reached; checking the heartbeat",
  hm_read: "read from Arkiv",
  hm_at: "at block {b}",
  hm_custodian: "Custodian {n}",
  hm_holding: "holding the key",
  hm_f1_t: "Check-in received",
  hm_f1: "heartbeat moved forward",
  hm_f2_t: "3 envelopes sealed",
  hm_f2: "owner 0x…dEaD · nobody can delete",
  hm_f3_t: "Custodian 2 renewed custody",
  hm_f3: "lease extended 14 days",
  mk_enc: "encrypted in this browser",
  mk_chunk: "chunk {i}",
  mk_sealed: "sealed",
  mk_2of3: "2 of 3 open the vault",
  mk_journalist: "Journalist",
  mk_lawyer: "Lawyer",
  mk_friend: "Friend",
  mk_slot: "slot {n}",
  mk_piece: "one piece of the key, encrypted to a one-time address",
  mk_any2: "Any two pieces rebuild the key. One alone is random noise.",
  mk_next: "Next check-in due in",
  mk_safe: "I'm safe · check in",
  mk_stopped: "Heartbeat stopped at block {b}",
  mk_published: "piece published",
  mk_stranger: "{a} (stranger)",
  mk_ignored: "ignored: wrong creator",
  mk_matches: "matches the hash sealed at block {b}",
  rh_week: "Weekly",
  rh_fortnight: "Fortnightly",
  rh_month: "Monthly",
  vp_rhythm: "Every {i} · grace {g} · {k} of {n} custodians · {mode}",
  vp_mode_newsroom: "release to a newsroom",
  vp_mode_public: "public release",
  rj_vault: "vault entity from a different creator",
  rj_manifest: "second manifest for the same vault; the first one counts",
  rj_heartbeat: "heartbeat not written by the vault's creator",
  rj_beat: "check-in note not written by the vault's creator",
  rj_envelope: "envelope not written by the vault's creator",
  rj_ack: "acknowledgement from a wallet that is not this slot's custodian",
  rj_release: "release from a wallet that is not this slot's custodian",
  nav_rti: "RTI clock",
  home_rti_eyebrow: "Filed an RTI?",
  home_rti_h2: "Know the day your reply is due.",
  home_rti_lead: "Enter the date the PIO received your application. The RTI clock gives you the reply deadline and both appeal windows under the RTI Act, and drafts your First Appeal in English, Hindi or Telugu if the reply doesn't come. It works today on any phone, and what you type stays in your browser.",
  home_rti_cta: "Open the RTI clock",
  rti_eyebrow: "RTI clock",
  rti_title: "When is your RTI reply due?",
  rti_lead: "Enter when the Public Information Officer received your application. You get the reply deadline and your appeal windows under the Right to Information Act, 2005, and a drafted First Appeal if the deadline passes in silence. What you type stays in this browser.",
  rti_form_t: "Your application",
  rti_received: "Date the PIO received it",
  rti_received_hint: "If you sent it by post, use the delivery date from India Post tracking. For an online filing, the date is on the acknowledgement.",
  rti_time: "Time",
  rti_kind: "What it asks about",
  rti_kind_normal: "Anything else: 30 days",
  rti_kind_life: "The life or liberty of a person: 48 hours",
  rti_apio: "I gave it to an Assistant PIO (5 more days)",
  rti_fee: "Days between the PIO's fee letter and your payment",
  rti_fee_hint: "Leave this at 0 unless the PIO asked for further fees. Those days don't count toward the deadline, s.7(3)(a).",
  rti_tl_t: "Your deadlines",
  rti_due: "Reply due",
  rti_due_s: "The PIO must give the information, or refuse with reasons, by then. s.7(1)",
  rti_due_apio: "Includes 5 days for the Assistant PIO. s.5(2)",
  rti_deemed: "If nothing comes",
  rti_deemed_s: "From the next day, silence counts as a refusal and you can appeal. If the PIO answers late, you are owed the information free of charge. s.7(2), s.7(6)",
  rti_fa: "First Appeal by",
  rti_fa_s: "To the First Appellate Authority, the officer senior to the PIO in the same public authority. A late appeal can still be admitted if you had sufficient cause. s.19(1)",
  rti_faa: "Appeal decision due",
  rti_faa_s: "Within 30 days of the authority receiving your appeal, 45 at most. Counted here from {date}. s.19(6)",
  rti_sa: "Second appeal by",
  rti_sa_s: "To the Central or State Information Commission, within 90 days of the date the First Appeal decision was due or reached you. s.19(3)",
  rti_left: "{n} left",
  rti_passed: "No reply by the deadline",
  rti_source: "Every period on this page comes from the Right to Information Act, 2005, and applies to central and state public authorities alike. Fees and forms differ from state to state, but these time limits are set by the Act.",
  rti_source_link: "Read the Act on India Code",
  rti_rec_t: "Timestamp it on Arkiv",
  rti_rec_lead: "Optional. Choose the application file or paste its text. This browser computes its SHA-256 fingerprint, then mixes it with a random 32-byte salt made on this device. Only that salted value and the block your reply is due go on chain. Without the salt nobody can test a guessed document or name against it, so the record says nothing about what you asked or who you are. Nobody can change or delete it, including you and us, and the block it was written in shows the application existed by then. It stays readable through the appeal windows and expires on its own 165 days after the reply deadline, when the second appeal window closes (s.19(1), s.19(6), s.19(3)).",
  rti_rec_net: "This runs on Arkiv's Tiramisu testnet. Keep your postal or online receipt as well: that is your proof the PIO received the application.",
  rti_rec_file: "Application file",
  rti_rec_text: "Or paste the application text",
  rti_rec_hash: "Fingerprint (SHA-256). It stays on this device.",
  rti_rec_go: "Record on Arkiv",
  rti_rec_gas: "Getting test gas for a one-time key…",
  rti_rec_write: "Writing the record…",
  rti_rec_late: "The reply deadline has passed, so a record now would time nothing. You can still draft the appeal below.",
  rti_rec_t2: "On Arkiv",
  rti_rec_by: "Recorded in block {block}, {time}, by the one-time key {addr}.",
  rti_rec_live: "The reply is due at block {due}. The record stays until block {block}, 165 days later, when the last appeal window closes (s.19(1), s.19(6), s.19(3)).",
  rti_rec_gone: "Expired at block {block}, when the last appeal window closed. Read here as it stood in block {at}.",
  rti_rec_none: "Each recording uses a new salt. Record an application once and keep its receipt.",
  rti_rec_link: "Save this link. It reopens this record and your deadlines on any device.",
  rti_rec_tx: "Transaction",
  rti_rec_rejected: "{n} entities with this tag failed a check and were ignored.",
  rti_rec_receipt_s: "Download the receipt now and keep it with your application. It holds the salt, which exists nowhere else. With the receipt and the application, anyone can check that this record is yours; without the receipt, the record can't be matched to anything.",
  rti_rec_receipt: "Download receipt",
  rti_rec_commit: "Salted value on Arkiv:",
  rti_rec_needreceipt: "To show this record belongs to an application, open its receipt and choose the application above.",
  rti_rec_badreceipt: "That file is not a Proof of Life RTI receipt, or its salt does not give the value it names.",
  rti_rec_nomatch: "This application does not match the receipt.",
  rti_rec_norecord: "No valid record with this receipt's value was found on Arkiv.",
  rti_rec_match: "This application matches the receipt, and the receipt matches the record on Arkiv.",
  rti_rec_open: "Recorded before? Open your receipt:",
  rti_letter_t: "First Appeal, ready to send",
  rti_letter_early: "The reply isn't due yet. This is the letter you would send if it doesn't come.",
  rti_letter_lead: "Fill in what you know. Blank fields stay in brackets for you to complete by hand. Nothing here is sent anywhere.",
  rti_l_lang: "Letter language",
  rti_l_name: "Your name",
  rti_l_addr: "Your address",
  rti_l_auth: "Public authority",
  rti_l_pio: "PIO's name or designation",
  rti_l_reg: "Application or registration number",
  rti_l_subject: "What you asked for (one line)",
  rti_l_reason: "Why the appeal is late",
  rti_l_copy: "Copy letter",
  rti_l_print: "Print",
  rti_ph_name: "[your name]",
  rti_ph_addr: "[your address]",
  rti_ph_auth: "[public authority and its address]",
  rti_ph_pio: "[PIO's name or designation]",
  rti_ph_reg: "[registration number]",
  rti_ph_subject: "[the information you asked for]",
  rti_ph_reason: "[reason for the delay]",
  rti_letter_body: "To\nThe First Appellate Authority\n{auth}\n\nFrom\n{name}\n{addr}\n\nDate: {today}\n\nSubject: First Appeal under section 19(1) of the Right to Information Act, 2005\n\nSir or Madam,\n\n1. On {filed}, the Public Information Officer ({pio}) of {auth} received my application under section 6 of the Right to Information Act, 2005 (registration number {reg}). It asked for: {subject}.\n\n2. Under section 7(1) of the Act, a decision was due by {due}. I have received none. Under section 7(2), the request is deemed to have been refused.\n\n3. {timing}\n{record}\nI request you to:\n(a) direct the Public Information Officer to provide the information asked for, free of charge under section 7(6), as the time limit was not met;\n(b) decide this appeal within the period set by section 19(6).\n\nEnclosed: a copy of the RTI application and proof of its delivery.\n\nYours faithfully,\n{name}",
  rti_letter_intime: "This appeal is filed within the thirty days allowed by section 19(1).",
  rti_letter_late: "This appeal is filed after the thirty days in section 19(1). I ask that it be admitted under the proviso to that section, because {reason}.",
  rti_letter_record: "\n4. A salted fingerprint of the application was recorded on the Arkiv network in block {block} on {time}, which shows the application existed by then: {link}\nI hold the receipt that matches this record to the enclosed copy of the application.\n",
  vl_ignored: " · {m} ignored",
  vl_size: "{c} × 96 KiB ciphertext · sealed {d}",
} as const;

export type Strings = { [K in keyof typeof en]: string };
